import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';

import WorkerRow from './WorkerRow';

import Button from '@/components/Button';
import DropdownMenu from '@/components/DropdownMenu';
import { PoolMemberRow } from '@/services/preferredPoolsAPI';
import { formatEventDate } from '@/util/datetime';
import styled from '@/styles';

// ui-prototype/preferred-worker-pool/client-detail.html #poolMemberList. The
// kebab (.menu-dots) opens a row menu whose only v1 action is Remove (plan
// F6); the prototype's heart toggle is a Favorites-tab delta with no backend
// in GRAVY-10265 and is not ported.

const EmptyState = styled('div', {
  padding: '48px 0',
  textAlign: 'center',
  color: '#979797',
  fontSize: '14px',
});

// GRAVY-10943 FP-2.10: seeded members say so, with the date they were added,
// so they can be told apart from nominations and manual adds.
const memberSourceLabel = (member: PoolMemberRow): string | null => {
  if (member.source !== 'favorites') return null;
  const date = member.added_at
    ? formatEventDate(new Date(member.added_at))
    : null;
  return date ? `From favorites · ${date}` : 'From favorites';
};

type Props = {
  members: PoolMemberRow[];
  skillName: string;
  onRemove: (member: PoolMemberRow) => void;
};

const MembersTable = ({ members, skillName, onRemove }: Props) => (
  <div data-testid="poolMemberList">
    {members.length === 0 ? (
      <EmptyState>No pool members yet</EmptyState>
    ) : (
      members.map((member) => (
        <WorkerRow
          key={member.membership_id}
          actions={
            <DropdownMenu
              actions={[
                [
                  {
                    label: 'Remove from pool',
                    onAction: () => onRemove(member),
                  },
                ],
              ]}
              justify="right"
            >
              <Button
                a11yLabel={`Actions for ${member.worker.name}`}
                appearance="plain"
                iconLeft={faEllipsisVertical}
              />
            </DropdownMenu>
          }
          inactive={!member.worker_active}
          notReadyReason={member.not_ready_reason}
          sourceLabel={memberSourceLabel(member)}
          rookie={member.rookie}
          shiftsInSkillTotal={member.shifts_in_skill_total}
          shiftsWithClient={member.shifts_with_client}
          skillName={skillName}
          tier={member.tier}
          worker={member.worker}
        />
      ))
    )}
  </div>
);

export default MembersTable;
